import { Group, Stack, ThemeIcon } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Icon, Text, brand } from '@zorro/web/design-system';

import className from './CardSelector.module.scss';
import { TCardSelectorOption } from './cardSelector.types';

export const SelectedCardOption = ({
  label,
  description,
  iconBgColor,
  icon,
  isReadOnly,
  opened,
  onClick,
}: TCardSelectorOption) => {
  return (
    <Group
      wrap="nowrap"
      gap="lg"
      py="md"
      pl="sm"
      align="flex-start"
      justify="space-between"
      flex="1 0 auto"
      onClick={onClick}
      className={className['selected-option']}
      data-opened={opened}
      data-readonly={isReadOnly}
    >
      <Group wrap="nowrap">
        <ThemeIcon color={iconBgColor} size={48} radius={4}>
          <Icon icon={icon} />
        </ThemeIcon>
        <Stack gap={0}>
          <Text fw={600}>{label}</Text>
          <Text size="sm" c={brand.zorroGray400}>
            {description}
          </Text>
        </Stack>
      </Group>
      {!isReadOnly && (
        <ActionIcon mr="md">
          <IconChevronDown />
        </ActionIcon>
      )}
    </Group>
  );
};
